import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Skeleton } from '@mui/material';
import { useMemo, useContext } from 'react';

import { Tabs } from 'app/shared-components/structure';
import { useNavigationHeader, useHeaderTitle } from 'app/hooks';

import { MasterServiceContext } from '../context/MasterServiceContext';

const tabs = [
  {
    label: 'Settings',
    value: 'settings',
    path: '../settings',
  },
  {
    label: 'Content',
    value: 'content',
    path: '../content',
  },
];

export default function MasterServiceDetailsLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { masterService, isMasterServiceLoading } = useContext(MasterServiceContext);

  useNavigationHeader({
    title: 'Back to master services',
    navigateTo: '/master-services',
  });

  const headerTitle = isMasterServiceLoading ? (
    <Skeleton variant="text" width={200} height={24} />
  ) : (
    masterService?.name
  );
  useHeaderTitle(headerTitle);

  const selectedTab = useMemo(
    () => tabs.find((tab) => location.pathname.endsWith(tab.value))?.value ?? tabs[0].value,
    [location.pathname]
  );

  function handleTabChange(event, newValue) {
    const newPath = tabs.find((tab) => tab.value === newValue)?.path;
    if (newPath) navigate(newPath, { relative: 'path', replace: true });
  }

  return (
    <Box className="grow flex flex-col px-20 py-16 gap-16 bg-white overflow-hidden">
      <Tabs tabs={tabs} selectedTab={selectedTab} handleChange={handleTabChange} />
      {children}
    </Box>
  );
}
